import { useEffect, useState } from "react";
import moment from "moment";
import { SupportedTimesEnum } from "src/types";
import { featureFlags } from "services/featureFlags";

const OFFICE_START_HOUR = 9;
const OFFICE_END_HOUR = 17;

export const useSupportedTimeStatusCheck = (): boolean => {
  const IsAiAgentSupport = featureFlags.IsAiAgentSupport();
  const [status, setStatus] = useState<SupportedTimesEnum>(
    SupportedTimesEnum.OUTSIDE_OFFICE_HOURS
  );

  const checkStatus = (): SupportedTimesEnum => {
    const now = moment();
    const day = now.day(); // 0 = Sunday, 6 = Saturday
    const isWeekday = day >= 1 && day <= 5;

    const start = moment().hour(OFFICE_START_HOUR).minute(0).second(0);
    const end = moment().hour(OFFICE_END_HOUR).minute(0).second(0);

    if (isWeekday && now.isBetween(start, end)) {
      return SupportedTimesEnum.OFFICE_HOURS;
    }

    return SupportedTimesEnum.OUTSIDE_OFFICE_HOURS;
  };

  useEffect(() => {
    setStatus(checkStatus());
  }, []);

  return IsAiAgentSupport.active
    ? IsAiAgentSupport.extra?.support_times === SupportedTimesEnum.ALWAYS
      ? true
      : status === IsAiAgentSupport.extra?.support_times
    : false;
};
